import _toString from 'lodash/toString';

/**
 * @module tools/Cookie
 * @description
 * вспомогательный модуль для работы с куками
 */
let Cookie = (name: string) => {
  let matches: Array<any> = document.cookie.match(new RegExp(
    '(?:^|; )' + _toString(name).replace(/([\.$?*|{}\(\)\[\]\\\/\+^])/g, '\\$1') + '=([^;]*)'
  ));

  return matches ? decodeURIComponent(matches[1]) : undefined;
};

export default Cookie;
